import { isEmpty } from 'lodash-es';
import styled, { css } from 'styled-components';
import { breakpoints } from '@klv/shared/utils/screen-size';

import type { DefaultTheme } from 'styled-components';
import type { TBreakpoints } from '@klv/shared/styles/types';
import type { IBaseGrid, TGridColumns } from '../types';

const createGridTemplateAreas = (count: number) => {
  const areas: string[] = [];

  for (let i = 0; i < count; i += 1) {
    areas.push(`col${i + 1}`);
  }

  return areas.join(' ');
};

const createGridBreakpoint = ({
  breakpoint, columnCount, omitPadding, theme,
}:
{ breakpoint?: TBreakpoints; columnCount: number; omitPadding?: boolean; theme: DefaultTheme; }) => {
  const cssValue = `
    column-gap: ${theme.screenSize[`s${breakpoint}` as keyof typeof theme.screenSize].gridColumnGap}rem;
    grid-template-areas: '${createGridTemplateAreas(columnCount)}';
    grid-template-columns: repeat(${columnCount}, 1fr);
    padding: ${!omitPadding ? `0 ${theme.screenSize[`s${breakpoint}` as keyof typeof theme.screenSize].gridHorizontalPadding}rem` : ''};
  `;

  return breakpoint && breakpoint > 380 ? `
    ${theme.screenSize[`s${breakpoint}`].mediaQuery} {
      ${cssValue}
    }
  ` : cssValue;
};

export const generateGridStyles = ({ columns = {}, omitPadding, theme }: { columns?: TGridColumns; omitPadding?: boolean; theme: DefaultTheme; }) => {
  const gridColumns = columns;

  if (isEmpty(gridColumns)) {
    breakpoints.forEach((breakpoint) => {
      gridColumns[breakpoint] = theme.screenSize[`s${breakpoint}`].gridColumns;
    });
  }

  const columnBreakpoints = Object.keys(gridColumns);
  const gridStyles: string[] = [];

  columnBreakpoints.forEach((breakpoint) => {
    if (gridColumns[breakpoint]) {
      gridStyles.push(createGridBreakpoint({
        breakpoint: Number(breakpoint) as TBreakpoints,
        columnCount: gridColumns[breakpoint] as number,
        omitPadding,
        theme,
      }));
    }
  });

  return gridStyles.join('\n\n');
};

const BaseGrid = styled.div<IBaseGrid>`
  ${({ theme }) => css`
    display: grid;
    grid-row-gap: 0px;
    grid-template-rows: 1fr;
    margin: 0 auto;
    max-width: ${theme.screenSize.s1366.size}rem;
    ${generateGridStyles({ theme })}
  `}
`;

export default BaseGrid;
